import { Injectable } from '@angular/core';

/**
 * Configuration service, provides default values for the AccordionComponent.
 */

export class AccordionConfig {
  /** Whether the other panels should be closed when a panel is opened */
  public closeOthers: Boolean = false;
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
